(function () {
  'use strict';

  /* @ngdoc object
   * @name printer
   * @description
   *
   */
  angular
    .module('printer', [
      'ui.router'
    ]);
}());
